export default function MySQL_CURRENT_TIMESTAMP() {
  return (
    <div>
      <h2>MySQL_CURRENT_TIMESTAMP</h2>    </div>
  );
}